import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

export default class ImageFile extends Icon {
  gradientId = this.getRandomId();

  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
    >
      <defs>
        <linearGradient
          id={this.gradientId}
          x1="1.831%"
          x2="20.694%"
          y1="0%"
          y2="98.008%"
        >
          <stop offset="0%" stopColor="#F28726" />
          <stop offset="100%" stopColor="#F26D26" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd" opacity={this.props.opacity}>
        <rect width="40" height="40" fill={`url(#${this.gradientId})`} rx="5" />
        <path
          fill="#FFF"
          d="M12.863 21.863L19 28l7.069-13.254c.26-.488.866-.672 1.353-.412.188.1.34.258.432.45l9.461 19.785c.239.498.028 1.095-.47 1.333-.135.065-.282.098-.432.098H3.87c-.553 0-1-.448-1-1 0-.197.058-.39.167-.555l8.287-12.43c.307-.46.928-.584 1.387-.277.055.036.106.078.153.125z"
        />
        <circle cx="13" cy="12" r="4" fill="#FFF" />
      </g>
    </svg>
  );
}

ImageFile.defaultProps = {
  opacity: '1.0',
};

ImageFile.propTypes = {
  opacity: PropTypes.string,
};
